export const appIds = {
  Drips: "633f8aa0-3449-48b2-977e-94fe9ba7b144",
  GatoradeCom: "ef66ee25-eb8f-40b1-af20-3da1b508b1b8",
  GatoradeTeamzone: "5557f6ea-7402-4309-a153-35c9faa52837",
  PantryShop: "b0414f96-89ee-4a2d-94ea-9b062d2a7212",
  PepsiCoShop: "ce256574-90a0-443b-b7a9-c68ea4dc178f",
  SodaStreamPL: "e0225c6f-2285-493c-8205-8f42a92b8655",
  SodaStreamUS: "ad39626e-fcb2-42d8-ba73-aa5f505d826c",
  Snacks: "672264e6-ede3-4a54-9115-8f195491033c",
  Poppi: "2879e6cf-4c86-420c-add0-ec8b68b49519",
};
